module.exports = __webpack_public_path__ + "img/loop.efa75771.svg";